export default function Education({ t }) {
  return (
    <section id="education-skills" className="premium-section">
      <div className="section-container">
        <div className="section-header">
          <span className="section-tag">Knowledge Base</span>
          <h3 className="section-title">Background & Skills</h3>
        </div>
        <div className="premium-grid">
          <div className="premium-card card-animated">
            <div className="card-gradient-border"></div>
            <div className="card-icon">
              <img src="/ikonlar/egitim.jpg" alt="Eğitim Logosu" />
            </div>
            <h4 className="card-title">{t.eduTitle}</h4>
            <div className="edu-timeline">
              <div className="edu-item">
                <div className="edu-dot"></div>
                <div className="edu-content">
                  <strong>{t.uni2}</strong>
                  <p className="card-desc">{t.dept}</p>
                  <span className="edu-date">{t.date || "2025 - 2028"}</span>
                </div>
              </div>
              <div className="edu-item">
                <div className="edu-dot"></div>
                <div className="edu-content">
                  <strong>{t.uni1}</strong>
                  <p className="card-desc">{t.dept}</p>
                  <span className="edu-date">2024 - 2025</span>
                </div>
              </div>
            </div>
            <div className="gpa-badge">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 10 3 12 0v-5"/></svg>
              {t.gpa}
            </div>
          </div>

          <div className="premium-card card-animated">
            <div className="card-gradient-border"></div>
            <div className="card-icon">
              <img src="/ikonlar/yetenek.png" alt="Skills" />
            </div>
            <h4 className="card-title">{t.skillsTitle}</h4>
            <div className="skills-list">
              {Array.isArray(t.skillsList) && t.skillsList.map((skill, i) => (
                <div key={i} className="skill-chip">
                  <span className="skill-dot"></span>
                  {skill}
                </div>
              ))}
            </div>
            
            <h4 className="card-title" style={{marginTop: '30px'}}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign: 'middle', marginRight: '8px'}}><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
              {t.langTitle}
            </h4>
            <div className="skills-list">
              {Array.isArray(t.langList) && t.langList.map((lang, i) => (
                <div key={i} className="skill-chip lang-chip">
                  <span className="skill-dot"></span>
                  {lang}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
